import { Form, Input, Row, Col, Radio, Switch, DatePicker, RadioChangeEvent, Select } from 'antd';
import { useRef, useState, useEffect } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const WebWxUserEdit = (props: any) => {
    const apiId = 'webWxUser';
    const [form] = Form.useForm();
    const { defaultService } = props;
    const ref = useRef<any>(undefined);
    const [genderData, setGenderData] = useState<any>();
    const [roleData, setRoleData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'role',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setRoleData(res.data);
                }
            });
    }, []);

    const onChangeGender = (e: RadioChangeEvent) => {
        setGenderData(e.target.value);
    };

    const extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        displayOptions: {
            width: 700
        },
        dateOptions: {
            columnNames: ['birthday']
        },
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={12}>
                    <Form.Item
                        label="unionId"
                        name="unionId">
                        <Input disabled={true} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="昵称"
                        name="nickName">
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label="角色"
                        name="roleIds" >
                        <Select
                            mode="multiple"
                            showSearch
                            placeholder="选择角色"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(roleData, { itemName: 'roleName' })}
                        </Select>
                    </Form.Item>
                </Col>


                <Col span={24}>
                    <Form.Item
                        label="头像"
                        name="avatarUrl">
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="姓名"
                        name="userName">
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="手机码"
                        name="mobile">
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="性别"
                        name="gender">
                        <Radio.Group onChange={onChangeGender} value={genderData}>
                            <Radio value={0}>女</Radio>
                            <Radio value={1}>男</Radio>
                        </Radio.Group>
                    </Form.Item>

                </Col>

                <Col span={7}>
                    <Form.Item
                        label="生日"
                        name="birthday">
                        <DatePicker
                            format="YYYY-MM-DD"
                        />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="销售员"
                        name="isSales"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

            </Row>)
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default WebWxUserEdit;